import announcements from '../data/announcements.json';

// Format date to human-readable string
function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

// Get emoji based on announcement type
function getTypeEmoji(type) {
  switch (type) {
    case 'feature':
      return '🎉';
    case 'update':
      return '✨';
    case 'fix':
      return '🔧';
    default:
      return '📢';
  }
}

function WhatsNew() {
  return (
    <div className="min-h-screen bg-puzzle-surface">
      <div className="max-w-3xl mx-auto px-4 py-12">
        {/* Header */}
        <h1 className="text-3xl font-bold text-puzzle-text mb-2">What&apos;s New</h1>
        <p className="text-puzzle-text-secondary mb-8">Recent updates and new features</p>

        {/* Announcements List */}
        <div className="space-y-6">
          {announcements.announcements.map((item) => (
            <article
              key={item.id}
              className="bg-puzzle-background rounded-lg p-6 border border-puzzle-border"
            >
              <div className="flex items-start gap-4">
                <span className="text-2xl flex-shrink-0">{getTypeEmoji(item.type)}</span>
                <div className="flex-1 min-w-0">
                  <h2 className="text-lg font-semibold text-puzzle-text mb-1">
                    {item.title}
                  </h2>
                  <p className="text-sm text-puzzle-text-secondary mb-3">
                    {formatDate(item.date)}
                  </p>
                  <p className="text-puzzle-text">
                    {item.message}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Empty State */}
        {announcements.announcements.length === 0 && (
          <div className="text-center py-12">
            <p className="text-puzzle-text-secondary">No announcements yet.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default WhatsNew;
